








































































































import { Component, Prop } from 'vue-property-decorator';
import { Student } from '../../../src_server/entity/generated/Student';
import { InputPages } from '../../components/organisms/InputPages';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';
import { Session } from '../../utils/Session';

@Component({ components: { ErrorSummary } })
export default class StudentPaymentPage extends InputPages {
  @Prop()
  value!: Student;
  get model(): Student {
    return this.value;
  }
  set model(value: Student) {
    this.value = value;
  }
  get isCO() {
    return Session.isCircleOBuilding();
  }
}
